import { isValid, parse } from 'date-fns';
import { z } from 'zod';

import { useParams as useBaseParams, useSearchParams as useBaseSearchParams } from '@/common/composables/router';
import { buildSearchParamsSortScheme } from '@/helpers/zod';

const paramsScheme = z.object({
  category: z.string().min(1).catch('all'),
  date: z.string().refine((value: string) => {
    const date = parse(value, 'yyyyMM', new Date());

    return isValid(date);
  }).catch(null),
  marketplace: z.enum(['etsy']).catch('etsy'),
});

export function useParams() {
  return useBaseParams(paramsScheme);
}

const searchParamsScheme = z.object({
  query: z.string().trim().catch(null),
}).merge(buildSearchParamsSortScheme(['searches', 'term']));

export type SearchParamsSchemeType = z.infer<typeof searchParamsScheme>;

export function useSearchParams() {
  return useBaseSearchParams(searchParamsScheme);
}
